import React from 'react';

function PricingSection() {
    return (
        //<!-- Pricing Section -->
        <section class="my-5 bg-light py-5" id="pricing">
            <div class="container">
                <h2 class="text-center mb-4">Simple Pricing</h2>
            </div>
        </section>
    )
}

export default PricingSection;